module.exports = __webpack_public_path__ + "img/Dantam Hair 44.c78c0405.jpg";